import React, { useEffect } from "react";
import {
  Button,
  FormControlLabel,
  Grid,
  InputLabel,
  Radio,
  Tooltip,
  Typography
} from "@material-ui/core";
import { connect } from "react-redux";
import _ from "lodash";
import { reduxForm, change, formValueSelector, Field } from "redux-form";
import { TextField, RadioGroup } from "redux-form-material-ui";
import {
  InputTextField,
  DatePicker,
  ReduxWysiwyg,
  InputNumberField,
  TreeField
} from "../../../../../components/Shared/Form/Fields";
import { required } from "js/components/Shared/Form/validations.js";
import { _t } from "js/utils/TranslationService";

let Form = props => {
  const {
    pristine,
    handleSubmit,
    submitting,
    classes,
    history,
    disabled,
    idPrograma,
    idNoticia,
    segmentosTree,
    segmentosSecciones = [],
    changeFieldValue,
    esPublico,
    requiereLogin
  } = props;
  useEffect(
    () => {
      if (!requiereLogin) {
        changeFieldValue("frecuenciaDiaria", 0);
        changeFieldValue("limiteDiasVisualizacion", 0);
      }
      if (!esPublico) {
        changeFieldValue("requiereLogin", true);
      }
    },
    [esPublico, requiereLogin, changeFieldValue]
  );

  const handleOnChangeSegmento = () => {
    segmentosTree.forEach(segmento => {
      const { children } = segmento;
      let selectedChildren = [];
      if (children && children.length > 0) {
        selectedChildren.push(
          ...children.filter(child => child.checked).map(child => child.value)
        );
      }
      let segmentoFound = segmentosSecciones.find(
        seg => seg.segmento.idSegmento === segmento.value
      );
      if (segmentoFound) {
        segmentoFound.secciones = selectedChildren;
      } else {
        if (selectedChildren.length > 0) {
          segmentosSecciones.push({
            segmento: { idSegmento: segmento.value },
            secciones: selectedChildren
          });
        }
      }
    });
    _.remove(segmentosSecciones, item => _.isEmpty(item.secciones));
  };

  const urls = {
    full: "",
    short: ""
  };

  if (window.location.pathname.indexOf("admin") !== -1) {
    urls.full = window.location.href.match(/(\/admin.*noticias)/)
      ? window.location.href.match(/(\/admin.*noticias)/)[0]
      : "admin/dashboard";
    urls.short = `/admin/programa/${idPrograma}/noticias/${idNoticia}`;
  }

  const handleOnChangeRequiereLogin = (event, value) => {
    changeFieldValue("requiereLogin", value);
  };

  const isRequiereLoginDisabled = !esPublico;
  const isFrecuenciaAndLimiteDisabled = requiereLogin === false || disabled;

  return (
    <>
      {/* <Grid className={classes.grid} container spacing={16}> */}
      <Grid container spacing={16}>
        <Grid item xs={12} style={{ display: "flex" }}>
          <Typography variant="h5" style={{ flex: 1 }}>
            {disabled ? "Ver " : idNoticia === "new" ? "Nuevo " : "Modificar "}
          </Typography>
        </Grid>
      </Grid>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={24}>
          <Grid item xs={12} sm={6}>
            <InputTextField
              required
              name="nombre"
              label="Nombre noticia"
              autoComplete="off"
              disabled={disabled}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DatePicker
              name={"fechaInicio"}
              dateFormat="DD/MM/YYYY"
              label={_t("Fecha inicio noticia")}
              autoOk
              disabled={disabled}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DatePicker
              name={"fechaFin"}
              dateFormat="DD/MM/YYYY"
              label={_t("Fecha Fin noticia")}
              autoOk
              disabled={disabled}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputNumberField
              name="limiteDiasVisualizacion"
              helperText="Cantidad de días en el periodo de tiempo que se visualizará la noticia"
              label="Límite días visualización"
              component={TextField}
              decimalNumbers={10}
              disabled={isFrecuenciaAndLimiteDisabled}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputNumberField
              name="frecuenciaDiaria"
              helperText="Cantidad de veces que se mostrará la noticia por día"
              label="Frecuencia diaria"
              component={TextField}
              decimalNumbers={10}
              disabled={isFrecuenciaAndLimiteDisabled}
              required
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <InputLabel htmlFor="requiereLogin">Requiere Login</InputLabel>
            <Field
              name="requiereLogin"
              component={RadioGroup}
              validate={required}
              style={{ flexDirection: "row" }}
              parse={value => value === "true"}
              disabled={isRequiereLoginDisabled}
              onChange={handleOnChangeRequiereLogin}
            >
              <FormControlLabel
                value={true}
                control={<Radio />}
                label="Activo"
                disabled={isRequiereLoginDisabled}
              />
              <FormControlLabel
                value={false}
                control={<Radio />}
                label="Inactivo"
                disabled={isRequiereLoginDisabled}
              />
            </Field>
          </Grid>
          {segmentosTree && (
            <Grid xs={12} sm={6}>
              <InputLabel>Segmentos & Secciones</InputLabel>
              <TreeField
                name="segmentosTree"
                label="Segmentos"
                data={segmentosTree}
                disabled={disabled}
                onChange={handleOnChangeSegmento}
                withTodos
              />
            </Grid>
          )}
          <Grid item xs={12}>
            <ReduxWysiwyg name={_t("Contenido")} inputName={"template"} />
          </Grid>
        </Grid>
        <Grid container>
          <Grid container item xs={12} sm={6}>
            <Button
              type="button"
              variant="outlined"
              size="large"
              color="primary"
              className={classes.actionBtns}
              onClick={e => history.push(urls.full)}
            >
              Cancelar
            </Button>
          </Grid>
          <Grid container item xs={12} sm={6} justify="flex-end">
            {disabled && (
              <Button
                type="button"
                variant="contained"
                size="large"
                color="primary"
                className={classes.actionBtns}
                onClick={() => history.push(urls.short + "/edit")}
              >
                Editar
              </Button>
            )}
            {!disabled && (
              <Button
                type="submit"
                variant="contained"
                size="large"
                color="primary"
                className={classes.actionBtns}
                disabled={pristine || submitting}
              >
                Guardar
              </Button>
            )}
            {/* <Grid className={classes.gridButton} item xs> */}
            {/* </><form className={classes.container} onSubmit={handleSubmit}> */}
          </Grid>
        </Grid>
      </form>
    </>
  );
};

/*
  * Registramos el formulario en el store de REDUX bajo el nombre de formNoticia
  * Props handleSubmit, pristine & submitting se inyectan automaticamente en el componente
*/
Form = reduxForm({
  form: "formNoticia",
  keepDirtyOnReinitialize: false,
  enableReinitialize: false
})(Form);

const selector = formValueSelector("formNoticia");

Form = connect(
  state => ({
    idPrograma: selector(state, "idPrograma"),
    idNoticia: selector(state, "idNoticia"),
    segmentosTree: selector(state, "segmentosTree"),
    segmentosSecciones: selector(state, "segmentosSecciones"),
    requiereLogin: selector(state, "requiereLogin")
  }),
  dispatch => ({
    changeFieldValue: (field, value) =>
      dispatch(change("formNoticia", field, value))
  })
)(Form);

export const FormNoticia = Form;
